<script>
  import Modal from './Modal.svelte';
  import { fade } from 'svelte/transition';
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  import { e, f, o, r, showModal, more} from './stores.js';
  let orientation=["efro", "erfo", "roef", "reof", "fero", "orfe", "foer"];
  let showModalSuggest=false;
  let questionAbrv="";
  let question="";
  let answer="";
  
  const suggestInput = function(x){
    questionAbrv=x;
    switch (questionAbrv) {
      case 'e':
        question = "What does this innovation enhance?"
        break;
      case 'f':
        question = "What does this innovation flip into?"
        break;
      case 'r':
        question = "What does this innovation retrieve?"
        break;
      case 'o':
        question = "What does this innovation obsolece?"
        break;
      default:
        question = 'Sorry, some error ';
    }
    answer="";
    showModalSuggest=true;
  }
  const suggestSubmit = function(){
    answer = answer.trim();
    if (answer.length!=0){
      let reply=":"+questionAbrv+" "+answer;
      //alert('will submit this= '+ reply);
      dispatch('suggestion', {suggestion: reply});
    }
    showModalSuggest=false;
  }
  // const spacer="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
  const spacer="";
</script>


<div class="tetrad efro">

  {#if showModalSuggest}
    <Modal on:close="{() => showModalSuggest=false}">
      <h2 slot="header">{question}</h2>
      <!-- <p>{question}</p> -->
      <input bind:value={answer} placeholder="enter your answer" size="40" maxlength="100">
      <button on:click={() => suggestSubmit() }>Suggest</button>
    </Modal>
  {/if}

  {#if $showModal}
    <Modal on:close="{() => showModal.set(false)}">
      <h2 slot="header">console help screen</h2>
      <p>In chat you can start your input with these commands below. For example, use  
      :r to replace the answer for retrieve. 
      To make "Elevator" the answer for retreive  type ":r Elevator".</p>
      <ul>
        <li>:e - replace enhancement</li>
        <li>:f - replace flip or reversal</li>
        <li>:o - replace obsolesces</li>
        <li>:r - replace retrieve</li>
        
        <li>:i - replace innovation</li>
        <li>:d - replace description</li>
        <li>:w - replace wikipedia link</li>
        <li>:s - replace source/event/publication</li>
        
        <!-- <li>:u - undo</li> 
        <li>:g - gloss (future)</li>
        <li>:b - add to biography (future)</li>
        <li>:z - zebra flag for inappropriate (future)</li>
        <li>:k - lock tetrad (future)</li>
        <li>:c - clone tetrad (future)</li> -->

      </ul>
    </Modal>
  {/if}
    <div class="tl">
      <div class="enhance quad">
        <!-- <div class="suggest" on:click={() => suggestInput('e') } class:hide="{!$more}">suggest</div> -->
        <div class="gf" class:hide="{!$more}">{@html spacer}figure</div>
        <div class="law">{$e}</div>
        <div class="abbrv">E</div>
      </div>
    </div>
    <div class="tr">
      <div class="flip quad">
        <!-- <div class="suggest" on:click={() => suggestInput('f') } class:hide="{!$more}">suggest</div> -->
        <div class="gf" class:hide="{!$more}">ground{@html spacer}</div>
        <div class="law">{$f}</div>
        <div class="abbrv">F</div>
      </div>
    </div>
    <div class="bl">
      <div transition:fade class="retrieve quad">
        <!-- <div class="suggest" on:click={() => suggestInput('r') } class:hide="{!$more}">suggest</div> -->
        <div class="gf" class:hide="{!$more}">{@html spacer}figure</div>
        <div class="law">{$r}</div>
        <div class="abbrv">R</div>
      </div>
    </div>
    <div class="br">
      <div class="obsolesces quad">
        <!-- <div class="suggest" on:click={() => suggestInput('o') } class:hide="{!$more}">suggest</div> -->
        <div class="gf" class:hide="{!$more}">ground{@html spacer}</div>
        <div transition:fade class="law">{$o}</div>
        <div class="abbrv">O</div>
      </div>
    </div>
  </div>

  <style>
    .tetrad {display: grid; 
      /* grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(2, 1fr);} */
      grid-template-columns: 1fr 1fr;
      grid-template-rows: auto;
    }
    /* rotation of tetrad */
    .retrieve {grid-area: r}
    .enhance {grid-area: e}
    .flip {grid-area: f}
    .obsolesces {grid-area: o}

    .efro {grid-template-areas: 
      "e f"
      "r o"  
    }
    .erfo {grid-template-areas:
      "e r"
      "f o"
    }
    .roef {grid-template-areas:
      "r o"
      "e f"}
    .reof {grid-template-areas:
      "r e"
      "o f"}
    .fero {grid-template-areas:
      "f e"
      "r o"}
    .orfe {grid-template-areas:
      "o r"
      "f e"}
    .foer {grid-template-areas:
      "f o"
      "e r"}
    .ofre {grid-template-areas:
      "o f"
      "r e"}

    .abbrv {font-weight: bold;}
    .law {font-size: 2rem; margin: 0.5rem 1rem;}
    .quad {margin: 0.5em;}
    .gf {text-align: center;}
    .suggest {text-align: center; padding: 1rem; font-weight: bold;}
    .suggest:hover {text-decoration: underline;  }
    .tl .quad {text-align: right;}
    .tr .quad {text-align: left;}
    .bl .quad {text-align: right; display: flex; flex-direction: column;}
    .bl .quad :nth-child(1) { order: 3; }
    .bl .quad :nth-child(2) { order: 2; }
    .bl .quad :nth-child(3) { order: 1; }

    .br .quad {text-align: left; display: flex; flex-direction: column;}
    .br .quad :nth-child(1) { order: 3; }
    .br .quad :nth-child(2) { order: 2; }
    .br .quad :nth-child(3) { order: 1; }

    .hide {visibility: hidden;}
  </style>
  